import importScript from './importScript';

let cacheBlackbox: string | null = null;

export function getBlackbox(): Promise<string | null> {
  return new Promise((resolve, reject) => {
    if (cacheBlackbox) {
      resolve(cacheBlackbox);
      return;
    }

    // 开发环境不加载同盾
    if (process.env.NODE_ENV === 'development') {
      resolve(null);
      return;
    }

    window._fmOpt = {
      partner: 'zhichengcredit',
      appName: 'yixianghua_web',
      token:
        'zhichengcredit' + '-' + new Date().getTime() + '-' + Math.random().toString(16).substr(2),
      fpHost: 'https://fp.tongdun.net',
      success: (blackbox: string) => {
        cacheBlackbox = blackbox;
        resolve(blackbox);
      },
    };

    importScript(
      ('https:' == document.location.protocol ? 'https://' : 'http://') +
        'static.tongdun.net/v3/fm.js?ver=0.1&t=' +
        (new Date().getTime() / 3600000).toFixed(0),
    ).catch(reject);
  });
}
